"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCROLL_OFFSET = exports.MENU_HEIGHT = void 0;
var _menu = _interopRequireDefault(require("../../scss/core/_menu.scss"));
var MENU_HEIGHT = parseInt(_menu.default.menuHeight, 10);
exports.MENU_HEIGHT = MENU_HEIGHT;
var SCROLL_OFFSET = 5;
exports.SCROLL_OFFSET = SCROLL_OFFSET;